module.exports = __webpack_public_path__ + "img/serp.901057fe.png";